import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStoreService } from '../../services/local-store.service';
declare var DevExpress;
@Component({
  selector: 'ppp-check-duplicate-popup',
  templateUrl: './check-duplicate-popup.component.html',
})
export class CheckDuplicatePopupComponent implements OnInit {
  currentUser: any = {};
  public itemForm: FormGroup;
  public sourceList: any = [];
  selectedProducts = [];
  landingPageList: any = [];
  duplicateList: any = [];
  url: any = null;
  level: any;

  constructor(
    private fb: FormBuilder,
    private local: LocalStoreService,
    private loader: NgxUiLoaderService
  ) {
    this.currentUser = this.local.getItem('currentUser');
  }

  ngOnInit(): void {
    this.buildItemForm();
  }

  buildItemForm() {
    this.itemForm = this.fb.group({
      phone: ['', Validators.required],
    });
  }

  onActivate(event) {
    if (event.type == 'click') {
      console.log(event.row);
      window.open(`/order?id=${event.row.Id}`, 'blank');
    }
  }

  submit() {
    this.loader.startLoader('loader02');
    const data = {
      ...this.itemForm.value,
      domain: this.currentUser.domain,
    };

    // this.crudService.checkDuplicateOrder(data).subscribe(
    //   (res: any) => {
    //     this.loader.stopLoader('loader02');
    //     if (res?.JSONData) {
    //       this.duplicateList = JSON.parse(res.JSONData);
    //     }
    //   },
    //   (err) => {
    //     this.loader.stopLoader('loader02');
    //   }
    // );
  }
}
